export default ElementUi => {
  const extendedElementUi = { ...ElementUi }
  const { mounted, beforeDestroy } = extendedElementUi.Option
  
  extendedElementUi.Option.mounted = function () {
    if (typeof mounted === 'function') mounted.bind(this)
    this.$el.addEventListener('touchstart', this.selectOptionClick, false)
  }
  
  extendedElementUi.Option.beforeDestroy = function () {
    this.$el.removeEventListener('touchstart', this.selectOptionClick)
    if (typeof beforeDestroy === 'function') beforeDestroy.bind(this)
  }

  return extendedElementUi
}
